import * as React from "react";
import {Header, Modal} from "semantic-ui-react";
import AceEditor from "react-ace";
import {selectedReportScript} from "../main/pages/scriptExecution/reportScript/ReportScriptSelection";


export interface AceModalProps {
    isOpen: boolean
    onClose: () => void
    title: string
    content: string
}

export function AceModal(props: AceModalProps) {


    function handleClose() {
        props.onClose()
    }

    return <Modal
        closeIcon
        open={props.isOpen}
        onClose={handleClose}
        dimmer="blurring"
        size='fullscreen'
    >
        <Header icon='browser' content={props.title}/>
        <Modal.Content>
            <AceEditor
                theme="monokai"
                mode="json"
                value={props.content}
                width={"100%"}
                height={"800px"}
                readOnly={true}
            />
        </Modal.Content>
    </Modal>
}

